// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.profile.RentalManagerUserProfileV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserProfileSaveUserInfoV2RequestDto, UserProfileSetNameV2RequestDto } from '../..';

export const RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Path = '/api/web/v2/users/profile/saveUserInfo';

/**
 * Set user info
 */
export const RentalManagerUserProfileV2WebApiHandler_saveUserInfo = (
  postData: UserProfileSaveUserInfoV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserProfileSaveUserInfoV2RequestDto, void>(
    {
      endpoint: RentalManagerUserProfileV2WebApiHandler_saveUserInfo_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserProfileV2WebApiHandler_setName_Path = '/api/web/v2/users/profile/setName';

/**
 * Set user's name
 */
export const RentalManagerUserProfileV2WebApiHandler_setName = (
  postData: UserProfileSetNameV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserProfileSetNameV2RequestDto, void>(
    {
      endpoint: RentalManagerUserProfileV2WebApiHandler_setName_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
